
const Pay = ()=>{

    return(
        <div className="py-5">
            <h1>Paymet method comming soon......</h1>
        </div>
    )
}
export default Pay;